/* eslint-disable  */
import React, { useEffect, useState } from 'react';
import { Container, Table, Header } from 'semantic-ui-react';
import { api } from '#/apis';
import Dimmer from '+/Dimmer';
import dayjs from 'dayjs';



const ViewEvictions = props => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(false);


    useEffect(() => {
        setLoading(true);
        api.get('/evictions')
            .then(({ data }) => {
                // console.log(data.rows)
                setData(data.rows);
                setLoading(false);
            })
            .catch(err => {
                setErr(true);
            });
    }, []);

    if (err){
        return <Dimmer message='SOMETHING WENT WRONG, PLEASE RELOAD PAGE' />;
    }

    if (loading || !data) return <Dimmer message='Loading....This may take a while.'/>;


    return (
        <Container fluid className='overflow-x'>
            <Header content='Evictions Report'/>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Property' />
                        <Table.HeaderCell content='Unit' />
                        <Table.HeaderCell content='File Date' />
                        <Table.HeaderCell content='Days Old' />
                        <Table.HeaderCell content='Total Owed' />
                        <Table.HeaderCell content='Notes' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {(data || []).map((property, i) => (
                        <Table.Row key={i}>
                            <Table.Cell content={property.property_name} />
                            <Table.Cell content={property.unit_name} />
                            <Table.Cell content={property.file_date ? dayjs(property.file_date.split('T')[0]).format('MM/DD/YYYY') : ""} />
                            <Table.Cell content={property.days_passed} />
                            <Table.Cell content={property.total_delinquent} />
                            <Table.Cell content={property.notes} />
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

        </Container>
    );
};


export default ViewEvictions;
